export default {
  setCreateResponse(state: any, response: any) {
    state.createResponse = response
  },

  setCreateBulkResponse(state: any, response: any) {
    state.createBulkResponse = response
  },
}
